export * from './auth.reducer';
export * from './controls.reducer';
export * from './hours.reducer';
export * from './projects.reducer';
export * from './reducer';



// WEBPACK FOOTER //
// ./src/store/reducers/index.ts